/*global Modernizr, trapFocus, console */
/*jslint browser:true */

(function() {
  'use strict';

  var search_modal_container = document.querySelector('.search-modal-container');

  if(search_modal_container) {
    search_modal_container.addEventListener('modal-open', (e) => {
      setTimeout(function() {
        search_modal_container.querySelector('input').focus();
      }, 30);
    });
  }
}());